let errorHTML = '';
const errorValues = document.getElementById('petrol-prices-error-values');

// API ERROR
export const apiError = container => {
	const errorTitle = `<h1>${errorValues.dataset.apierror}</h1>`;
	const errorHTML = `
        <div>
            <div class="note__title">
                <div>
                    <h2>${errorTitle}</h2>
                <div>
            </div>
        </div>
    `;
	container.innerHTML = errorHTML;
};

// NEED TO LOG IN TO VIEW RESULTS
export const needToLogInView = container => {
	const errorMessage =
		document.getElementById('petrol-prices-error-LoginToViewText').innerHTML ||
		'There was a problem displaying your results.';
	const errorTitle = `<h1>${errorValues.dataset.needtologinviewtitle}</h1>`;
	createErrorMessageHTML(errorMessage, errorTitle, false);

	container.innerHTML = errorHTML;
};

// EXCEEDED WEEKLY LOOKUPS
export const exceededLookups = container => {
	const errorMessage = `<p>${errorValues.dataset.exceededlookupsmessage}</p>`;
	const errorTitle = `<h1>${errorValues.dataset.exceededlookupstitle}</h1>`;
	createErrorMessageHTML(errorMessage, errorTitle, true);

	container.innerHTML = errorHTML;
};

export const noResultsFound = (container, authenticated) => {
	const errorMessage =
		document.getElementById('petrol-prices-error-LoginToViewText').innerHTML ||
		'There was a problem displaying your results.';
	const errorTitle = errorValues.dataset.noresultstitle;
	const backToSearch = errorValues.dataset.backtosearch;
	errorHTML = '';
	if (authenticated) {
		errorHTML = `
            <div>
                <div class="note__title">
                    <div>
                        <h2>${errorTitle}</h2>
                    <div>
                </div>
            </div>
            <div>
                <a class="arrow-link--back body-3 spacer" href="javascript:location.reload(true);" id="backToSearch">
                    <span class="arrow-link__title">${backToSearch}</span>
                </a>
            </div>
        `;
	} else {
		errorHTML = `
            <div>
                <div class="note__title">
                    <div>
                        <h2>${errorTitle}</h2>
                    <div>
                </div>
            </div>
            <div>
                <a class="arrow-link--back body-3 spacer" href="javascript:location.reload(true);" id="backToSearch">
                    <span class="arrow-link__title">${backToSearch}</span>
                </a>
            </div>
            <div class="note note--panel note--icon spacer">
                <div class="icon icon--medium">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" version="1.1"><title>Exclamation mark icon</title><g transform="translate(-3883 -10668)"><rect x="3883" y="10668" width="24" height="24"></rect><g><path d="M3895,10688.2c-1.3,0-2.1-0.9-2.1-1.9c0-1.1,0.9-2,2.1-2c1.3,0,2.1,0.9,2.1,2
                C3897.1,10687.3,3896.3,10688.2,3895,10688.2z M3893,10672.7h3.9l-0.4,10.1h-3L3893,10672.7z" class="detail"></path></g></g></svg>
                </div>
                <div class="note__content">
                    <div>
                        ${errorMessage}
                    </div>
                </div>
            </div>
        `;
	}
	container.innerHTML = errorHTML;
};

export const createErrorMessageHTML = (errorMessage, errorTitle, homepageButton) => {
	const homepageButtonHTML = `
        <div class="spacer">
            <a href="${errorValues.dataset.createerrormessagehtmlbuttonlink}" class="btn" role="button">${errorValues.dataset.createerrormessagehtmlbutton}</a>
        </div>
    `;
	errorHTML = '';
	errorHTML = `
        <div>
            <div class="note__title">
                <div>
                    ${errorTitle}
                <div>
            </div>
        </div>
        <div class="note note--panel note--icon spacer">
            <div class="icon icon--medium">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" version="1.1"><title>Exclamation mark icon</title><g transform="translate(-3883 -10668)"><rect x="3883" y="10668" width="24" height="24"></rect><g><path d="M3895,10688.2c-1.3,0-2.1-0.9-2.1-1.9c0-1.1,0.9-2,2.1-2c1.3,0,2.1,0.9,2.1,2
            C3897.1,10687.3,3896.3,10688.2,3895,10688.2z M3893,10672.7h3.9l-0.4,10.1h-3L3893,10672.7z" class="detail"></path></g></g></svg>
            </div>
            <div class="note__content">
                <div>
                    ${errorMessage}
                </div>
            </div>
        </div>
        ${homepageButton ? homepageButtonHTML : ''}`;
	return errorHTML;
};
